import {
  Stack
} from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import { useForm } from "react-hook-form";
import { NodeProps, useReactFlow } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import SelectNpc from "../../base/SelectNpc";
import SelectRoom from "../../base/SelectRoom";
import { Start, StartNodeWithChildren } from "./StartNode";

interface FormData extends Start {
  npcId: string;
  roomName: string
}

const StartByInteractingWithNpcNode: React.FC<NodeProps<NodeType<FormData>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const formData = nodeData as FormData | undefined;
  const npcId = formData?.npcId;
  
  const roomName = nodeData?.roomName ?? "";

  const { register, getValues, setValue, handleSubmit } = useForm<FormData>({
    defaultValues: {
      npcId,
      roomName,
    },
    mode: "onBlur",
  });

  const reactFlow = useReactFlow();

  const handleUpdate = useCallback(
    ({ npcId, roomName }: FormData) => {
      reactFlow.setNodes((nodes) => {
        const node = nodes.find(({ id }) => id === nodeId);

        if (node == null) {
          return nodes;
        }

        const nodeDataCloned = structuredClone(node.data) as NodeType;

        const nodeData = (nodeDataCloned.nodeData as FormData) ?? {};
        nodeData.npcId = npcId;
        nodeData.roomName = roomName;

        node.data = {
          ...nodeDataCloned,
          nodeData,
        };

        return nodes;
      });
    },
    [reactFlow]
  );

  return (
    <StartNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack>
          <SelectNpc value={getValues("npcId")} setValue={(value) => setValue("npcId", value)} color={color} />
          <SelectRoom value={roomName} setValue={(value)=>setValue("roomName", value)} color={color} />
        </Stack>
      </form>
    </StartNodeWithChildren>
  );
};

export default memo(StartByInteractingWithNpcNode);
